<!-- cv简历信息-爱好与特长 -->
<template>
  <div class='hobby-container'>
    <cv-hobby-detail />
  </div>
</template>

<script>
import cvHobbyDetail from './components/cv-hobby-detail'
export default {
  name: '',
  components: {
    cvHobbyDetail
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
